import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCategories } from '../api';
import { categories as fallbackCategories } from '../data';

export default function FeaturedCategories() {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const [categories, setCategories] = useState(fallbackCategories);

  useEffect(() => {
    getCategories()
      .then(res => {
        if (res.success && res.categories?.length > 0) {
          setCategories(res.categories.map(c => ({
            id: c.id,
            name: c.name,
            image: c.image_url,
          })));
        }
      })
      .catch(() => {}); // silently fall back to data.js
  }, []);

  const scroll = (dir) => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: dir * 220, behavior: 'smooth' });
  };

  const handleCategoryClick = (cat) => {
    navigate(`/category/${encodeURIComponent(cat.name)}/${cat.id}`);
  };

  return (
    <section style={{ marginTop: '2.5rem' }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#111827' }}>Featured Categories</h2>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => scroll(-1)} style={{ width: 32, height: 32, border: '1px solid #d1d5db', borderRadius: '50%', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6"/></svg>
            </button>
            <button onClick={() => scroll(1)} style={{ width: 32, height: 32, border: '1px solid #d1d5db', borderRadius: '50%', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6"/></svg>
            </button>
          </div>
        </div>
        <div ref={scrollRef} className="category-scroll" style={{ display: 'flex', gap: '1rem', overflowX: 'auto', paddingBottom: '8px' }}>
          {categories.map(cat => (
            <div
              key={cat.id}
              onClick={() => handleCategoryClick(cat)}
              style={{ flexShrink: 0, width: 140, cursor: 'pointer' }}
            >
              <div style={{
                border: '1px solid #e5e7eb', borderRadius: '10px',
                padding: '1rem', textAlign: 'center', background: '#fff',
                transition: 'border-color 0.2s, box-shadow 0.2s, transform 0.2s',
                height: '140px',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px',
              }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = '#16a34a';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(22,163,74,0.12)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ width: 56, height: 56, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img
                    src={cat.image}
                    alt={cat.name}
                    style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: '8px', display: 'block' }}
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                </div>
                <div style={{ fontSize: '0.78rem', fontWeight: 600, color: '#374151', lineHeight: 1.3 }}>{cat.name}</div>
                <div style={{ fontSize: '0.68rem', color: '#16a34a' }}>Shop Now →</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
